module.exports = __webpack_public_path__ + "img/043.0c826da5.png";